import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import SegmentIntersector from './SegmentIntersector';
var IntersectionAdder = /*#__PURE__*/function () {
  function IntersectionAdder() {
    _classCallCheck(this, IntersectionAdder);
    IntersectionAdder.constructor_.apply(this, arguments);
  }
  _createClass(IntersectionAdder, [{
    key: "isTrivialIntersection",
    value: function isTrivialIntersection(e0, segIndex0, e1, segIndex1) {
      if (e0 === e1) if (this._li.getIntersectionNum() === 1) {
        if (IntersectionAdder.isAdjacentSegments(segIndex0, segIndex1)) return true;
        if (e0.isClosed()) {
          var maxSegIndex = e0.size() - 1;
          if (segIndex0 === 0 && segIndex1 === maxSegIndex || segIndex1 === 0 && segIndex0 === maxSegIndex) return true;
        }
      }
      return false;
    }
  }, {
    key: "getProperIntersectionPoint",
    value: function getProperIntersectionPoint() {
      return this._properIntersectionPoint;
    }
  }, {
    key: "hasProperInteriorIntersection",
    value: function hasProperInteriorIntersection() {
      return this._hasProperInterior;
    }
  }, {
    key: "getLineIntersector",
    value: function getLineIntersector() {
      return this._li;
    }
  }, {
    key: "hasProperIntersection",
    value: function hasProperIntersection() {
      return this._hasProper;
    }
  }, {
    key: "processIntersections",
    value: function processIntersections(e0, segIndex0, e1, segIndex1) {
      if (e0 === e1 && segIndex0 === segIndex1) return null;
      this.numTests++;
      var p00 = e0.getCoordinates()[segIndex0];
      var p01 = e0.getCoordinates()[segIndex0 + 1];
      var p10 = e1.getCoordinates()[segIndex1];
      var p11 = e1.getCoordinates()[segIndex1 + 1];
      this._li.computeIntersection(p00, p01, p10, p11);
      if (this._li.hasIntersection()) {
        this.numIntersections++;
        if (this._li.isInteriorIntersection()) {
          this.numInteriorIntersections++;
          this._hasInterior = true;
        }
        if (!this.isTrivialIntersection(e0, segIndex0, e1, segIndex1)) {
          this._hasIntersection = true;
          e0.addIntersections(this._li, segIndex0, 0);
          e1.addIntersections(this._li, segIndex1, 1);
          if (this._li.isProper()) {
            this.numProperIntersections++;
            this._hasProper = true;
            this._hasProperInterior = true;
          }
        }
      }
    }
  }, {
    key: "hasIntersection",
    value: function hasIntersection() {
      return this._hasIntersection;
    }
  }, {
    key: "isDone",
    value: function isDone() {
      return false;
    }
  }, {
    key: "hasInteriorIntersection",
    value: function hasInteriorIntersection() {
      return this._hasInterior;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [SegmentIntersector];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._hasIntersection = false;
      this._hasProper = false;
      this._hasProperInterior = false;
      this._hasInterior = false;
      this._properIntersectionPoint = null;
      this._li = null;
      this._isSelfIntersection = null;
      this.numIntersections = 0;
      this.numInteriorIntersections = 0;
      this.numProperIntersections = 0;
      this.numTests = 0;
      var li = arguments[0];
      this._li = li;
    }
  }, {
    key: "isAdjacentSegments",
    value: function isAdjacentSegments(i1, i2) {
      return Math.abs(i1 - i2) === 1;
    }
  }]);
  return IntersectionAdder;
}();
export { IntersectionAdder as default };